module.exports = __webpack_public_path__ + "img/mp3.07ca5d77.png";